import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import HeroSection from "../../components/heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import { FaEnvelope, FaInfoCircle } from "react-icons/fa";
import "../registerDriverPage/RegisterDriverPage.css";
import Footer from "../../components/footer/Footer";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../../api/apiSystem";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

export default function ForgetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const showSuccessAlert = (message) => {
    Swal.fire({
      icon: 'success',
      title: t("forgetPassword.successTitle"),
      text: message,
      confirmButtonText: t("common.ok"),
      confirmButtonColor: '#28a745',
      timer: 4000,
      timerProgressBar: true,
      didClose: () => {
        // Optional: Redirect or clear form after alert closes
        setEmail("");
      }
    });
  };

  const showErrorAlert = (message) => {
    Swal.fire({
      icon: 'error',
      title: t("forgetPassword.errorTitle"),
      text: message,
      confirmButtonText: t("common.tryAgain"),
      confirmButtonColor: '#dc3545'
    });
  };

  // const showInfoAlert = () => {
  //   Swal.fire({
  //     icon: 'info',
  //     title: t("forgetPassword.infoTitle"),
  //     text: t("forgetPassword.infoMessage"),
  //     confirmButtonText: t("common.understand"),
  //     confirmButtonColor: '#17a2b8'
  //   });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic email validation
    if (!email || !email.includes('@')) {
      showErrorAlert(t("forgetPassword.errorMessage.invalidEmail"));
      return;
    }

    setLoading(true);

    try {
      const res = await authAPI.forgotPassword({ email });
      if (res.success) {
        showSuccessAlert(t("forgetPassword.successMessage"));
        localStorage.setItem("reset_email", email);
        
        // Optional: Show info alert after success
        // setTimeout(() => {
        //   showInfoAlert();
        // }, 2000);
        
      } else {
        showErrorAlert(res.message || t("forgetPassword.errorMessage.resetFailed"));
      }
    } catch (err) {
      showErrorAlert(t("forgetPassword.errorMessage.generic"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HeroSection
        backgroundImage={heroPhoto}
        title={t("forgetPassword.heroSection.title")}
        titleHighlight={t("forgetPassword.heroSection.titleHighlight")}
        showTopbar={false}
        showNavbar={true}
        features={t("forgetPassword.heroSection.features", { returnObjects: true })}
        showQuoteForm={false}
        showCTAButton={false}
        customHeight="100%"
      />

      <div className="dark-bg-primary register-driver-section">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="shadow-lg p-4 border-0 register-driver-card">
                <Card.Body>
                  <h4 className="text-center mb-4 text-dark fw-bold">
                    {t("forgetPassword.title")}
                  </h4>
                  <p className="text-center text-muted mb-4">
                    {t("forgetPassword.description")}
                  </p>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formEmail">
                      <Form.Label>{t("forgetPassword.emailLabel")}</Form.Label>
                      <div className="position-relative">
                        <FaEnvelope className="form-icon" />
                        <Form.Control
                          type="email"
                          placeholder={t("forgetPassword.emailPlaceholder")}
                          className="ps-5"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="warning"
                      className="w-100 mt-4 bg-orange-500 text-white"
                      disabled={loading}
                    >
                      {loading ? t("forgetPassword.submitButtonLoading") : t("forgetPassword.submitButton")}
                    </Button>
                  </Form>
                  
                  {/* Additional help text */}
                  {/* <div className="text-center mt-3">
                    <small className="text-muted">
                      {t("forgetPassword.helpText")}
                    </small>
                  </div> */}
                  {email && email.length > 0 && (
                    <div className="text-center mt-3">
                      <FaInfoCircle className="me-1" />
                      <small className="text-muted">
                        {t("forgetPassword.helpText")}
                      </small>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
}